import React, { useState } from 'react'
import Lightbox from 'react-image-lightbox';
import { firebase, database } from '../Firebase/firebase';
import Avatar from 'react-avatar';
import Moment from 'react-moment';
import { Button, Spinner, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { getAsanaWallTaskById, isUserAllowed } from '../Constants/Functions';
import { firebaseCollections, visibilityStatesArr, postTypesArr, calendarStrings } from '../Constants/Variables';

import AppModal from '../Components/AppModal';
import Comments from './Comments';
import AsanaStatusTag from './AsanaStatusTag';
import AppDropdown from './AppDropdown';

import '../Styles/Components/Post.scss';

export default function Post(props) {

    const [removePostModalShown, setRemovePostModalShown] = useState(false);
    const [asanaTaskLinkModalShown, setAsanaTaskLinkModalShown] = useState(false);
    const [isCommentsMenuOpen, setIsCommentsMenuOpen] = useState(false);
    const [enteredTaskId, setEnteredTaskId] = useState(props.post.asana ? props.post.asana.id : "");

    const [imageLightboxShown, setImageLightboxShown] = useState(false);
    const [isTaskLinkActionLoading, setIsTaskLinkActionLoading] = useState(false);
    const postTypesIconSrcArr = ["/images/operations_icon.png", "images/environment_icon.png", "images/training_icon.png"];

    var post = props.post;
    var likes = post.likes;
    var comments = post.comments;

    var provider = props.provider;
    var fbaccount = props.fbaccount;
    var account = provider.account;

    const lightboxImages = post.image ? [post.image.url] : [];

    const commentMenuToggleHandler = () => {
        setIsCommentsMenuOpen(!isCommentsMenuOpen);
    }

    const likePostHandler = () => {
        var didUserLike = likes.filter((like, i) => { return like.user.name === account.name ? { index: i } : false }).length;
        if (didUserLike) {
            post.likes.splice(didUserLike.index, 1);
            // post.likes = newLikesArr;
        } else {
            post.likes.push({
                user: {
                    uid: account.accountIdentifier,
                    name: account.name
                }
            })
        }

        //Update Likes fiels in Firebase Post Doc
        database.collection(firebaseCollections.thewall).doc(post.id).update({
            likes: post.likes
        }).then(function () {
            console.log("Finished setting like state to feedback post on firebase db.");
        })
            .catch(function (error) {
                console.error("Error adding document: ", error);
            });
    }

    const hidePostRemovePrompt = () => {
        setRemovePostModalShown(false);
    }

    const hideAsanaTaskLinkModal = () => {
        setAsanaTaskLinkModalShown(false);
    }


    const handleAsanaTaskLink = () => {
        setIsTaskLinkActionLoading(true);
        getAsanaWallTaskById(enteredTaskId).then((task) => {
            console.log(task)
            setIsTaskLinkActionLoading(false);

            if (task) {
                database.collection(firebaseCollections.thewall).doc(post.id).update({
                    asana: task
                }).then(function () {
                    console.log("Finished linking asana task to feedback post on firebase db.");
                })
                    .catch(function (error) {
                        console.error("Error adding document: ", error);
                    });
            }
        })
    }

    const handleAsanaTaskUnlink = () => {
        setIsTaskLinkActionLoading(true);
        database.collection(firebaseCollections.thewall).doc(post.id).update({
            asana: firebase.firestore.FieldValue.delete()
        }).then(function () {
            console.log("Finished linking asana task to feedback post on firebase db.");
            setIsTaskLinkActionLoading(false);
            setEnteredTaskId("");
        })
            .catch(function (error) {
                console.error("Error adding document: ", error);
            });
    }

    //need to set up drop down to select type of feedback posted
    const onFeedbackTypeSelect = selectedItemIndex => {
        database.collection(firebaseCollections.thewall).doc(post.id).update({
            type: {
                index: selectedItemIndex,
                name: postTypesArr.slice(1)[selectedItemIndex]
            }
        }).then(function () {
            console.log("Finished updating post type state to feedback post on firebase db.");
        })
            .catch(function (error) {
                console.error("Error adding document: ", error);
            });

        // setSelectedFeedbackType(selectedItemIndex);
        //<AppDropdown defaultvalue={postTypesArr[selectedPostType]} headertitle="Feedback Type" items={postTypesArr} darktone={false.toString()} alignright={true} style={{ fontSize: "1em", color: "#424242" }} onSelect={onTypeSelect} activeindex={selectedPostType} />
    }

    return (
        <div className="Post--Wrapper">
            <div className="Post--Tabs-Container">
                {
                    isUserAllowed(fbaccount.role, "editPostType") || (post.user.name === account.name) ?
                        (
                            <span className="Post--Type-Tag"><img className="Post--Type-Tag--Img img-fluid" src={postTypesIconSrcArr[post.type.index]} alt="Tag Icon" /><AppDropdown className="Post-Type-Dropdown" defaultvalue={post.type.name} headertitle="Feedback Type" items={postTypesArr.slice(1)} alignright={true} onSelect={onFeedbackTypeSelect} activeindex={post.type.index} /></span>
                        ) :
                        (
                            <span className="Post--Type-Tag"><img className="Post--Type-Tag--Img img-fluid" src={postTypesIconSrcArr[post.type.index]} alt="Tag Icon" /> <span className="Post-Type-Label">{postTypesArr.slice(1)[post.type.index]}</span></span>
                        )
                }
            </div>
            <div className="Post">
                <div className="Post--Header">
                    <div className="Post--Header--Row">
                        <div>
                            <Avatar name={post.user.name} round={true} textSizeRatio={2.2} size="36px" color="White" maxInitials={2} className="AppNavbar--Profile-Container--Avatar" />
                        </div>
                        <div className="Post-Header-Details">
                            <div>
                                <p className="Post--Header--Username">{post.user.name}</p>
                                <p className="Post--Header--Caption"><Moment calendar={calendarStrings}>{post.timestamp.toDate()}</Moment></p>
                            </div>
                            <div className="Post-Header-Details--Rightside">
                                {
                                    post.asana ? <AsanaStatusTag title={post.asana.title} description={post.asana.description} status={post.asana.status} id={post.asana.id} /> : null
                                }
                                {
                                    visibilityStatesArr[post.visibility] === "Private" ?
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip>Visible to you and admins</Tooltip>}
                                        >
                                            <img className="Post--Lock-Icon" src="/images/lock_icon.png" alt="lock icon" />
                                        </OverlayTrigger>
                                        : null
                                }

                                {
                                    isUserAllowed(fbaccount.role, "linkPostTasks") || (post.user.name === account.name) || isUserAllowed(fbaccount.role, "deletePosts") ?
                                        (
                                            <Dropdown>
                                                <Dropdown.Toggle className="App--primary-text-btn Post--Options-Btn"><img src="/images/v_dots_icon.png" alt="options button" /></Dropdown.Toggle>
                                                <Dropdown.Menu className="Post--Options-Btn--Menu" alignRight={true}>
                                                    <Dropdown.Header>Settings</Dropdown.Header>
                                                    {
                                                        (post.user.name === account.name) || isUserAllowed(fbaccount.role, "deletePosts") ? <Dropdown.Item className="App--Dropdown-Menu-Item" onClick={() => { setRemovePostModalShown(true) }} eventKey="2">Remove</Dropdown.Item> :
                                                            null
                                                    }
                                                    {
                                                        isUserAllowed(fbaccount.role, "linkPostTasks") ? <Dropdown.Item className="App--Dropdown-Menu-Item" onClick={() => { setAsanaTaskLinkModalShown(true) }} eventKey="3">Link Task</Dropdown.Item> : null
                                                    }

                                                </Dropdown.Menu>
                                            </Dropdown>
                                        ) : null
                                }

                            </div>
                        </div>
                    </div>
                </div>
                <div className="Post--Body">
                    <hr style={{ margin: '0 0 1em 0' }} />
                    <p className="Post--Body--Message">{post.message}</p>
                    {post.image ? <img onClick={() => { setImageLightboxShown(true) }} className="Post--Message--Img" src={post.image.url} alt="uploaded file" /> : null}
                    <div className="Post--Body--Reactions">
                        {
                            likes.length ?
                                <div className="Post--Body--Reactions--Reaction">
                                    <img src="/images/like_active_icon.png" alt="like icon" />
                                    <span>{likes.length}</span>
                                </div> : null
                        }
                        {
                            comments.length ?
                                <div className="Post--Body--Reactions--Reaction">
                                    <img src="/images/comment_active_icon.png" alt="comment icon" />
                                    <span>{comments.length}</span>
                                </div> : null
                        }

                    </div>
                    <hr style={{ margin: 0 }} />
                    <div className="Post--Footer">
                        <div className="Post--Footer--Leftside">
                            {
                                likes.filter((like) => { return like.user.name === account.name }).length ?
                                    <Button className="App--primary-text-btn Post--Like-Btn Active" onClick={likePostHandler}>Like<img src="/images/like_active_icon.png" alt="like button" /></Button> :
                                    <Button className="App--primary-text-btn Post--Like-Btn" onClick={likePostHandler}>Like<img src="/images/like_icon.png" alt="like button" /></Button>
                            }
                        </div>
                        <div className="Post--Footer--Rightside">
                            {
                                isCommentsMenuOpen ?
                                    <Button className="App--primary-text-btn Post--Comment-Btn Active" onClick={commentMenuToggleHandler} >Comment<img src="/images/comment_active_icon.png" alt="comment button" /></Button> :
                                    <Button className="App--primary-text-btn Post--Comment-Btn" onClick={commentMenuToggleHandler}>Comment<img src="/images/comment_icon.png" alt="comment button" /></Button>
                            }
                        </div>
                    </div>
                </div>
                {
                    isCommentsMenuOpen ?
                        <Comments fbaccount={fbaccount} post={post} account={account} permittedtocomment={true} /> : null

                }

            </div>
            {
                removePostModalShown ?
                    <AppModal onHide={hidePostRemovePrompt} className="Post--RemovePostModal">
                        <p className="Post--RemovePostModal--Title">Remove Post</p>
                        <p className="Post--RemovePostModal--Text">You are about to remove a feedback post. Are you sure you want to proceed?</p>
                        <div className="Post--RemovePostModal--Buttons">
                            <Button className="App--secondary-text-btn" onClick={() => { props.onRemove(post.id, post.image ? post.image.id : null); setRemovePostModalShown(false); }}>Yes</Button>
                            <Button className="App--primary-text-btn" onClick={() => { setRemovePostModalShown(false) }}>No</Button>
                        </div>
                    </AppModal> :
                    null
            }

            {
                asanaTaskLinkModalShown ?
                    <AppModal hasCloseBtn={true} onHide={hideAsanaTaskLinkModal} className="Post--AsanaTaskLinkModal">
                        <div className="Post--AsanaTaskLinkModal--Container">
                            <img className="Post--AsanaTaskLinkModal--LinkIcon" src="images/link_icon.png" alt="paperclip icon" />
                            <input type="text" value={enteredTaskId} className="Post--AsanaTaskLinkModal--Input" placeholder="Asana Task ID #" onChange={(e) => { setEnteredTaskId(e.currentTarget.value) }} />
                        </div>
                        {
                            isTaskLinkActionLoading ?
                                (
                                    <div className="Post--AsanaTaskLinking--Spinner">
                                        <Spinner
                                            as="span"
                                            animation="grow"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    </div>
                                ) :
                                <div className="Post--AsanaTaskLinkModal--ActionButtons-Container">
                                    <Button className="App--primary-btn" onClick={handleAsanaTaskLink}>{post.asana ? "Update" : "Link"}</Button>
                                    {
                                        post.asana ? <Button className="App--secondary-btn" onClick={handleAsanaTaskUnlink}>Unlink</Button> : null
                                    }
                                </div>
                        }

                    </AppModal> :
                    null
            }


            {
                lightboxImages ?
                    (
                        imageLightboxShown && (
                            <Lightbox
                                mainSrc={lightboxImages[0]}
                                nextSrc={lightboxImages[(0 + 1) % lightboxImages.length]}
                                prevSrc={lightboxImages[(0 + lightboxImages.length - 1) % lightboxImages.length]}
                                onCloseRequest={() => { setImageLightboxShown(false) }}
                                imageCaption={post.message}
                                imageTitle={`Shared by ${post.user.name}`}
                            />
                        )
                    ) : null
            }
        </div>
    )
}
